(function(angular){
	'use strict';
	
	angular.module('ratingsAndReviewsModule', [
		'coreModule'
	]);

})(window.angular);